import { useEffect, useRef } from 'react';

interface JsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function JsonLd({ data }: JsonLdProps) {
  const prevKeyRef = useRef<string>('');

  useEffect(() => {
    const currentKey = JSON.stringify(data);
    if (currentKey === prevKeyRef.current) return;
    prevKeyRef.current = currentKey;

    const items = Array.isArray(data) ? data : [data];
    const scripts: HTMLScriptElement[] = [];

    items.forEach((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-jsonld', 'true');
      script.textContent = JSON.stringify(item, null, 0);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, [data]);

  return null;
}